import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SupportIconComponent } from './components/support-icon/support-icon.component';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { SupportContainerComponent } from './components/support-container/support-container.component';
import { ChatModule } from '../chat/chat.module';
import { FaqModule } from '../../faq/faq.module';
import { SupportDemoComponent } from './components/support-demo/support-demo.component';
import { SupportIconViewComponent } from './views/support-icon-view/support-icon-view.component';
import { StoreModule } from '@ngrx/store';
import { supportReducer } from './actions/reducers';
import { SupportContainerViewComponent } from './views/support-container-view/support-container-view.component';
import { VisualGuideModule } from 'ZalamoLibrary/src/lib/ui/visual-guide/visual-guide.module';

@NgModule({
  declarations: [
    SupportIconComponent,
    SupportContainerComponent,
    SupportDemoComponent,
    SupportIconViewComponent,
    SupportContainerViewComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatBadgeModule,
    ChatModule,
    FaqModule,
    StoreModule.forFeature('support', {
      state: supportReducer,
    }),
    VisualGuideModule,
  ],
  exports: [
    SupportContainerComponent,
    SupportContainerViewComponent,
    SupportIconViewComponent,
  ],
})
export class SupportModule {
  constructor() {
    console.log('SUPPORT MODULE IMPORTED');
  }
}
